
import { BaseAppConfig } from 'lib-customizations/types'

import { env, Env } from './env'

type AppConfigs = {
  default: BaseAppConfig
} & {
  [k in Env]: BaseAppConfig
}

const employeeConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
}

const employeeMobileConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
}

const citizenConfigs: AppConfigs = {
  default: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
  staging: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
  prod: {
    sentry: {
      dsn: 'https://9f958f5ad818401191ca152f0171b2db@sentry.haltu.net/46',
      enabled: true,
    },
  },
}

const employeeConfig = employeeConfigs[env()]
const employeeMobileConfig = employeeMobileConfigs[env()]
const citizenConfig = citizenConfigs[env()]

export { employeeConfig, employeeMobileConfig, citizenConfig }
